import type { PlatformInfo, ReleaseSourceConfig } from '@/types'

/*
 * Where Ocuvia's downloadable builds come from.
 *
 * githubRepo: the GitHub repository that publishes Ocuvia builds as release
 *   assets, written as "owner/name". When set, version, date, files, sizes and
 *   SHA-256 digests are read straight from GitHub Releases.
 *
 * manual: a build hosted somewhere else (for example Modulify storage). Every
 *   value must come from the real file. Leave sizeBytes or sha256 out when unknown.
 *
 * While both are empty the site shows an honest "Release being prepared" state.
 */
export const releaseSource: ReleaseSourceConfig = {
    githubRepo: '',
    manual: null
}

export const platforms: PlatformInfo[] = [
    {
        id: 'linux',
        name: 'Linux',
        architecture: 'x86-64',
        label: "Linux x86-64",
        plannedFormats: "AppImage, .deb or another verified package",
        unavailableLabel: "Release being prepared",
        unavailableNote: "The first verified Linux build is being prepared. Its version, file size and SHA-256 checksum will appear here the moment it is published.",
        unavailableAction: 'none'
    },
    {
        id: 'windows',
        name: 'Windows',
        architecture: 'x64',
        label: "Windows x64",
        plannedFormats: ".exe or .msi installer",
        unavailableLabel: "Coming soon",
        unavailableNote: "A Windows installer is not available yet. It will be listed here only once a real, verified build exists.",
        unavailableAction: 'disabled'
    }
]
